// Życzonka: karta produktu. Zdjęcia, kolor wariantu i dodanie do koszyka bez przeładowania.
(() => {
  const root = () => window.Shopify?.routes?.root || '/';

  function init(el) {
    const main = el.querySelector('[data-pd-main]'), thumbs = el.querySelectorAll('[data-pd-thumb]');
    thumbs.forEach(t => t.addEventListener('click', () => {
      main.src = t.dataset.src; main.alt = t.dataset.alt;
      thumbs.forEach(x => x.setAttribute('aria-pressed', x === t));
      const row = t.parentElement; // na telefonie miniatury są w jednym przewijanym rzędzie
      if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: t.offsetLeft - row.offsetLeft - 8, behavior: 'smooth' });
    }));
    el.querySelectorAll('[data-pd-step]').forEach(b => b.addEventListener('click', () => {
      const list = [...thumbs], i = list.findIndex(t => t.getAttribute('aria-pressed') === 'true');
      list[(i + Number(b.dataset.pdStep) + list.length) % list.length].click();
    }));

    const form = el.querySelector('form'), id = el.querySelector('[data-pd-id]'), add = el.querySelector('[data-pd-add]'), status = el.querySelector('[data-pd-status]');
    const swatches = el.querySelectorAll('[data-pd-variant]');
    // pasek na telefonie: widoczny, gdy główny przycisk jest poza ekranem
    const bar = el.querySelector('[data-pd-bar]'), barAdd = el.querySelector('[data-pd-bar-add]');
    barAdd.addEventListener('click', () => form.requestSubmit());
    new IntersectionObserver(([e]) => { bar.hidden = e.isIntersecting; }).observe(add);
    swatches.forEach(s => s.addEventListener('click', () => {
      swatches.forEach(x => x.setAttribute('aria-pressed', x === s));
      id.value = s.dataset.pdVariant;
      el.querySelector('[data-pd-price]').textContent = s.dataset.price;
      el.querySelector('[data-pd-color]').textContent = s.getAttribute('aria-label');
      const ok = s.dataset.available === 'true';
      add.disabled = !ok; add.textContent = ok ? 'Do koszyka' : 'Chwilowo niedostępne';
      el.querySelector('[data-pd-bar-price]').textContent = s.dataset.price;
      el.querySelector('[data-pd-bar-color]').textContent = s.getAttribute('aria-label');
      barAdd.disabled = !ok; barAdd.textContent = ok ? 'Do koszyka' : 'Niedostępne';
      status.textContent = '';
      [...thumbs].find(t => t.dataset.media === s.dataset.media)?.click();
      const url = new URL(location.href); url.searchParams.set('variant', s.dataset.pdVariant); history.replaceState(null, '', url);
    }));

    form.addEventListener('submit', async e => {
      e.preventDefault();
      status.textContent = 'Dodajemy…'; add.disabled = true; barAdd.disabled = true;
      try {
        const r = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id.value), quantity: 1 }] }) });
        if (!r.ok) throw Error();
        await window.zyCart.refresh(); window.zyCart.open();
        status.textContent = 'Dodano do koszyka. ';
        const link = document.createElement('a'); link.href = root() + 'cart'; link.textContent = 'Zobacz koszyk'; status.append(link);
      } catch { status.textContent = 'Nie udało się dodać. Spróbuj ponownie.'; }
      add.disabled = false; barAdd.disabled = false;
    });
  }

  document.querySelectorAll('[data-zy-product]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-zy-product]').forEach(init));
})();
